// ReSharper disable once InconsistentNaming
(function (window, $) {
    "use strict";

    function SiteContext() {
        // overwritten in _Layout.cshtml
        this.language = 'de';
        this.environment = 'Live';
        this.privacyLink = null;
        this.imprintLink = null;

        // bootstrap 4 breakpoints
        this.breakpoints = {
            de: { min: 0, max: 576 - .2 },
            xs: { min: 576, max: 768 - .2 },
            sm: { min: 768, max: 992 - .2 },
            md: { min: 992, max: 1200 - .2 },
            lg: { min: 1200, max: 1400 - .2 },
            xl: { min: 1400, max: Infinity }
        };

        // a simple services container:
        this.services = {};
    }


    SiteContext.prototype.registerService = function (name, factory) {
        this.services[name] = factory;
    };

    SiteContext.prototype.getService = function (name) {
        var factoryName = name;
        var instanceName = name + '_Ø';

        var service = this.services[instanceName];
        if (!service) {
            var factory = this.services[factoryName];
            if (!factory) throw new Error("No service for '" + name + "' registered!");
            this.services[instanceName] = service = factory();
        }

        return service;
    };


    SiteContext.prototype.ready = function(cb) {
        if (document.readyState !== 'loading') cb();
        else document.addEventListener('DOMContentLoaded', cb);
    }


    SiteContext.prototype.mapBylang = function (de, it, en) {
        switch (this.language) {
            default:
            case 'de':
                return de;
            case 'it':
                return it;
            case 'en':
                return en;
        }
    };


    SiteContext.prototype.triggerReflow = function () {
        // use 'site' instead of 'this' because $(..).slideUp(site.triggerReflow) binds the element as this 😢
        window.site.getService('PageEvents').trigger('html-reflow');
    };


    SiteContext.prototype.debounce = function(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };


    SiteContext.prototype.scrollOffset = function () { return (window.innerWidth ? 60 : 120); };
    SiteContext.prototype.scrollToHash = function (hash, delay, offset) {
        var _ = this;
        offset = offset || 0;
        delay = delay || 0;
        if (hash && hash !== "#" && !/&/.test(hash)) {

            // hash campaign tracking
            if (/utm_/.test(hash)) {
                return false;
            }

            var e = $(hash);
            if (e.length) {

                setTimeout(function () {
                    offset = offset + _.scrollOffset();

                    $(document).scrollTo(e, 600, { offset: -offset });
                }, delay);
                return true;
            }
        }
        return false;
    };

    // export instance
    var defaults = new SiteContext();
    window.site = $.extend(defaults, window.site || {});


})(window, jQuery);


$(function ($) {
    "use strict";

    $(document).ready(function () {
        site.scrollToHash(window.location.hash.replace("/", ""), 500);

        $(document).on("click", "a[href^='#'], a[href^='" + window.location.pathname + "#']", function (e) {

            if ($(e.currentTarget).attr('css-target')) {
                return undefined;
            }

            var hash = e.currentTarget.getAttribute('href').replace(/^[^#]*/i, '');
            var offset = +e.currentTarget.getAttribute('offset') || 0;

            if (site.scrollToHash(hash, 0, offset)) {
                e.preventDefault();
                return false;
            }

            return undefined;
        });
    });
});